import { Accordion, AccordionButton, AccordionItem, AccordionPanel } from '@chakra-ui/accordion'
import { Box, Text } from '@chakra-ui/layout'
import React from 'react'
import { contactnumber } from '../../lib/Constants'
import { Minusicon, Plusicon } from '../Atoms/icon'

const Questions = () => {
    return (
        <Box
            mx="auto"
            maxW="90vw"
            transition="0.5 ease-out">
            <Box my="5rem"
                mx={{ base: '0rem', sm: '0rem', md: '2rem', lg: '2rem', xl: '2rem' }}
            >
                <Text
                    className='footer-FAQ'
                    textAlign="center"
                    color="#FB1923"
                    textTransform="uppercase"
                    fontWeight="bold"
                    fontSize="3xl"
                    letterSpacing="3px"
                >FREQUENTLY ASKED QUESTIONS</Text>
                <Box mx={{ base: '0rem', sm: '1rem', md: '2rem', lg: '2rem', xl: '4rem' }} mt="4rem">
                    <Accordion className='toggle_class' allowToggle>
                        <AccordionItem borderTop="none">
                            {({ isExpanded }) => (
                                <>
                                    < h2 >
                                        <AccordionButton>
                                            <Box as="span" flex='1' textAlign='left'>
                                                Do we charge for our service?
                                            </Box>
                                            {isExpanded ? (
                                                <Minusicon />
                                            ) : (
                                                <Plusicon />
                                            )}
                                        </AccordionButton>
                                    </h2>
                                    < AccordionPanel pb={4}>
                                        HelpNow is a non-profit organisation (soon to be registered under Section-8), run by students and alumni of IIT Bombay and AIIMS Delhi. All our services are provided at a nominal charge with Zero Margin. We strive to perfect our quick response model, surpassing the Western countries in response time and quality while making this a free service for all Indian citizens by 2024.
                                    </AccordionPanel>
                                </>
                            )}
                        </AccordionItem>

                        <AccordionItem>
                            {({ isExpanded }) => (
                                <>
                                    <h2>
                                        <AccordionButton>
                                            <Box as="span" flex='1' textAlign='left'>
                                                If you have zero margin, how will you grow and expand across India?
                                            </Box>
                                            {isExpanded ? (
                                                <Minusicon />
                                            ) : (
                                                <Plusicon />
                                            )}
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel pb={4}>
                                        We began with a ₹2 Lakh grant by IIT Bombay. Ever since the organisation runs on funds donated by IIT Bombay alumni, other IIT alumni, citizens who love us and the money we collect by extending our service. Additionally, we run a parallel Pvt. Ltd. to provide medical support to large corporates, event companies, production houses and private hospitals on a for-profit basis. All Profits and funds from this Pvt. Ltd. are utilised to scale our core mission at HelpNow.
                                    </AccordionPanel>
                                </>
                            )}

                        </AccordionItem>
                        <AccordionItem>
                            {({ isExpanded }) => (
                                <>
                                    <h2>
                                        <AccordionButton>
                                            <Box as="span" flex='1' textAlign='left'>
                                                Do you provide doctor or nurse at home?
                                            </Box>
                                            {isExpanded ? (
                                                <Minusicon />
                                            ) : (
                                                <Plusicon />
                                            )}
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel pb={4}>
                                        Our network of HelpNow Doctors and Nurses are trained to check, treat and care for you at the comfort of your home. Call us and our team arrives at your doorstep in a few minutes using one of our quick response ambulances.
                                    </AccordionPanel>
                                </>)}

                        </AccordionItem>
                        <AccordionItem>
                            {({ isExpanded }) => (
                                <>
                                    <h2>
                                        <AccordionButton>
                                            <Box as="span" flex='1' textAlign='left'>
                                                I have a question and want to talk with your team
                                            </Box>
                                            {isExpanded ? (
                                                <Minusicon />
                                            ) : (
                                                <Plusicon />
                                            )}
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel pb={4}>
                                        We’d love to chat with you. To receive a call back, call our customer support number {contactnumber}. Reach out anytime and we promise to hear you patiently and share more about our organisation.
                                    </AccordionPanel>
                                </>)}

                        </AccordionItem>
                        <AccordionItem>
                            {({ isExpanded }) => (
                                <>
                                    <h2>
                                        <AccordionButton>
                                            <Box as="span" flex='1' textAlign='left'>
                                                I faced a problem with your service and or call responder.
                                            </Box>
                                            {isExpanded ? (
                                                <Minusicon />
                                            ) : (
                                                <Plusicon />
                                            )}
                                        </AccordionButton>
                                    </h2>
                                    <AccordionPanel pb={4}>
                                        We follow a strict Patient First Policy. Although our call responders, ambulance drivers, medical staff and private partners are thoroughly trained in patient protocols and audited regularly, some discrepancies and mistakes may happen occasionally. Please feel free to reach us anytime on care@getHelpNow.in. We’ll call you back and try our best to resolve the issue.
                                    </AccordionPanel>
                                </>)}
                        </AccordionItem>
                    </Accordion>
                </Box>
            </Box>
        </Box >
    )
}

export default Questions